import { render, staticRenderFns } from "./RingPureColor.vue?vue&type=template&id=a56ef7be&scoped=true"
import script from "./RingPureColor.vue?vue&type=script&lang=js"
export * from "./RingPureColor.vue?vue&type=script&lang=js"
import style0 from "./RingPureColor.vue?vue&type=style&index=0&id=a56ef7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56ef7be",
  null
  
)

export default component.exports